import {
    API,
    graphqlOperation
} from "aws-amplify";
import {
    list_designations
} from "@/graphql/queries.js";
export const GetDesgination = {
    data: () => ({

        GetDesginationitems: []

    }),
    methods: {
        async GetDesgination() {
            try {

                let result = await API.graphql(
                    graphqlOperation(list_designations, {
                        input: {
                            organisation_id:
                                this.$store.getters.get_org_details[0].organisation_id,

                        },
                    })
                );
                this.GetDesginationitems = [];
                var response = JSON.parse(result.data.list_designations);
                if (response.Status == "SUCCESS") {
                    this.GetDesginationitems = response.data;
                }
                else {
                    this.GetDesginationitems = [];
                }
            } catch (err) {
                this.GetDesginationitems = [];
                console.log("erro location", err);
                this.$store.commit("snackbar/showMessage", {
                    content: err.errors[0].message,
                    color: "red",
                });
            }
        },
    }
}